import {
  GET_RANGE_SKIN_BODY_CARE,
  GET_RANGE_HAIR_CARE,
  GET_RANGE_HAIR_COLOR,
  GET_RANGE_MAKE_UP,
  GET_RANGE_MENS,
  GET_RANGE_PERM,
  GET_RANGE_STYLING,
  GET_HAIR_DIAGNOSIS,
  GET_STYLIST_TOOL,
  GET_SALON_VISIT_TOOL,
} from '../constants';

/**
 * The reducer saves first level product references
 * and replaces the rest with slugs. For use case so far,
 * this takes care of circular references
 * since we are not using the data nested that deep.
 */

const discardNestedReferences = data => ({
  ...data,
  productLists: data.productLists
    ? data.productLists.map(list => ({
        ...list,
        products: list.products
          ? list.products.map(product => ({
              ...product,
              instructionSteps: product.instructionSteps
                ? product.instructionSteps.map(step => ({
                    ...step,
                    productsUsed: step.productsUsed ? step.productsUsed.map(({ slug }) => slug) : undefined,
                  }))
                : undefined,
              relatedProducts: product.relatedProducts ? product.relatedProducts.map(({ slug }) => slug) : undefined,
              range: product.range
                ? {
                    ...product.range,
                    productLists:
                      product.range.productLists &&
                      product.range.productLists.map(productList => ({
                        ...productList,
                        products: productList.products.map(p => p.slug),
                      })),
                  }
                : {},
            }))
          : undefined,
      }))
    : undefined,
});

const getCorrectRanges = (rangeType, ranges) => {
  const correctRanges = ranges.reduce((obj, range) => {
    if (range.contentType === rangeType) {
      const flattenedRange = discardNestedReferences(range);
      return {
        ...obj,
        [flattenedRange.slug]: flattenedRange,
      };
    }
    return obj;
  }, {});
  return correctRanges;
};

const getRangesArrFromHairDiagnosis = data =>
  data.questions.reduce((arr, question) => {
    const questionRanges = question.answers.reduce((arr, answer) => {
      if (answer.results) {
        return arr.concat(answer.results);
      }
      return arr;
    }, []);
    if (questionRanges.length > 0) {
      return arr.concat(questionRanges);
    }
    return arr;
  }, []);

export const productRangeSkinBodyCare = (state = {}, action) => {
  switch (action.type) {
    case `${GET_RANGE_SKIN_BODY_CARE}_PENDING`:
      return state;
    case `${GET_RANGE_SKIN_BODY_CARE}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        [data.slug]: discardNestedReferences(data),
      };
    }
    case `${GET_HAIR_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeSkinBodyCare', getRangesArrFromHairDiagnosis(data)),
      };
    }
    case `${GET_STYLIST_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeSkinBodyCare', data.colorRanges),
        ...getCorrectRanges('productRangeSkinBodyCare', data.developerRanges),
      };
    }
    case `${GET_SALON_VISIT_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeSkinBodyCare', data.colorRanges),
        ...getCorrectRanges('productRangeSkinBodyCare', data.developerRanges),
      };
    }
    case `${GET_RANGE_SKIN_BODY_CARE}_REJECTED`:
      return state;
    default:
      return state;
  }
};

export const productRangeHairCare = (state = {}, action) => {
  switch (action.type) {
    case `${GET_RANGE_HAIR_CARE}_PENDING`:
      return state;
    case `${GET_RANGE_HAIR_CARE}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        [data.slug]: discardNestedReferences(data),
      };
    }
    case `${GET_HAIR_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeHairCare', getRangesArrFromHairDiagnosis(data)),
      };
    }
    case `${GET_STYLIST_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeHairCare', data.colorRanges),
        ...getCorrectRanges('productRangeHairCare', data.developerRanges),
      };
    }
    case `${GET_SALON_VISIT_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeHairCare', data.colorRanges),
        ...getCorrectRanges('productRangeHairCare', data.developerRanges),
      };
    }
    case `${GET_RANGE_HAIR_CARE}_REJECTED`:
      return state;
    default:
      return state;
  }
};

export const productRangeHairColor = (state = {}, action) => {
  switch (action.type) {
    case `${GET_RANGE_HAIR_COLOR}_PENDING`:
      return state;
    case `${GET_RANGE_HAIR_COLOR}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        [data.slug]: discardNestedReferences(data),
      };
    }
    case `${GET_HAIR_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeHairColor', getRangesArrFromHairDiagnosis(data)),
      };
    }
    case `${GET_STYLIST_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeHairColor', data.colorRanges),
        ...getCorrectRanges('productRangeHairColor', data.developerRanges),
      };
    }
    case `${GET_SALON_VISIT_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeHairColor', data.colorRanges),
        ...getCorrectRanges('productRangeHairColor', data.developerRanges),
      };
    }
    case `${GET_RANGE_HAIR_COLOR}_REJECTED`:
      return state;
    default:
      return state;
  }
};

export const productRangeMakeUp = (state = {}, action) => {
  switch (action.type) {
    case `${GET_RANGE_MAKE_UP}_PENDING`:
      return state;
    case `${GET_RANGE_MAKE_UP}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        [data.slug]: discardNestedReferences(data),
      };
    }
    case `${GET_HAIR_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeMakeUp', getRangesArrFromHairDiagnosis(data)),
      };
    }
    case `${GET_STYLIST_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeMakeUp', data.colorRanges),
        ...getCorrectRanges('productRangeMakeUp', data.developerRanges),
      };
    }
    case `${GET_SALON_VISIT_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeMakeUp', data.colorRanges),
        ...getCorrectRanges('productRangeMakeUp', data.developerRanges),
      };
    }
    case `${GET_RANGE_MAKE_UP}_REJECTED`:
      return state;
    default:
      return state;
  }
};

export const productRangeMens = (state = {}, action) => {
  switch (action.type) {
    case `${GET_RANGE_MENS}_PENDING`:
      return state;
    case `${GET_RANGE_MENS}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        [data.slug]: discardNestedReferences(data),
      };
    }
    case `${GET_HAIR_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeMens', getRangesArrFromHairDiagnosis(data)),
      };
    }
    case `${GET_STYLIST_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeMens', data.colorRanges),
        ...getCorrectRanges('productRangeMens', data.developerRanges),
      };
    }
    case `${GET_SALON_VISIT_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeMens', data.colorRanges),
        ...getCorrectRanges('productRangeMens', data.developerRanges),
      };
    }
    case `${GET_RANGE_MENS}_REJECTED`:
      return state;
    default:
      return state;
  }
};

export const productRangePerm = (state = {}, action) => {
  switch (action.type) {
    case `${GET_RANGE_PERM}_PENDING`:
      return state;
    case `${GET_RANGE_PERM}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        [data.slug]: discardNestedReferences(data),
      };
    }
    case `${GET_HAIR_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangePerm', getRangesArrFromHairDiagnosis(data)),
      };
    }
    case `${GET_STYLIST_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangePerm', data.colorRanges),
        ...getCorrectRanges('productRangePerm', data.developerRanges),
      };
    }
    case `${GET_SALON_VISIT_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangePerm', data.colorRanges),
        ...getCorrectRanges('productRangePerm', data.developerRanges),
      };
    }
    case `${GET_RANGE_PERM}_REJECTED`:
      return state;
    default:
      return state;
  }
};

export const productRangeStyling = (state = {}, action) => {
  switch (action.type) {
    case `${GET_RANGE_STYLING}_PENDING`:
      return state;
    case `${GET_RANGE_STYLING}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        [data.slug]: discardNestedReferences(data),
      };
    }
    case `${GET_HAIR_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeStyling', getRangesArrFromHairDiagnosis(data)),
      };
    }
    case `${GET_STYLIST_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeStyling', data.colorRanges),
        ...getCorrectRanges('productRangeStyling', data.developerRanges),
      };
    }
    case `${GET_SALON_VISIT_TOOL}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        ...getCorrectRanges('productRangeStyling', data.colorRanges),
        ...getCorrectRanges('productRangeStyling', data.developerRanges),
      };
    }
    case `${GET_RANGE_STYLING}_REJECTED`:
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/productRange.js